/**
 * Maps pageTypes keys (from /catalog/footer_config API) to Nuxt route names.
 * Route names are without locale suffix (e.g. "shop-basket", not "shop-basket___hu").
 *
 * Note: the [...slug] catch-all route handles SEO-friendly URLs (.p-, .c-, .b-.c-).
 * For those, use RESOURCE_TYPE_TO_PAGE_TYPE with urlResourceStore.data.resourceType.
 */
export const CATALOG_FOOTER_PAGE_TYPE_ROUTE_MAP: Record<string, string[]> = {
  dh_homepage: [
    'index',
  ],
  ecom_homepage: [
    'shop',
  ],
  catalogs: [
    'catalog',
  ],
  other_cms: [
    'content-id',
  ],
  product_list: [
    'product-list-id',
  ],
  product: [
    'product-id',
  ],
  comparison: [
    'shop-compare',
  ],
  shortlist: [
    'shop-list-list_name',
  ],
  boutiques: [],
  cart: [
    'shop-basket',
  ],
  checkout: [
    'shop-checkout-type',
  ],
  order_success: [
    'shop-checkout-success-orderIdent',
  ],
  delivery_map: [
    'food-delivery-map',
  ],
  gift_card: [
    'gift-card-order-success-orderIdent',
    'ajandekkartya-igenyles',
  ],
  safety_sheets: [
    'safety-data-sheet',
  ],
  loyalty_profile: [
    'shop-profile-loyalty-program',
    'shop-profile-loyalty-card',
    'shop-profile-loyalty-card-coupons',
    'shop-profile-loyalty-card-partner-program',
    'shop-profile-loyalty-card-transactions',
    'shop-profile-loyalty-card-stickers',
    'shop-profile-loyalty-card-stickers-id',
    'loyalty-program-faq',
  ],
  profile: [
    'shop-profile-manage',
    'shop-profile-data',
    'shop-profile-billing-addresses',
    'shop-profile-delivery-addresses',
    'shop-profile-mailing-addresses',
    'shop-profile-cards',
    'shop-profile-saved-baskets',
  ],
  orders: [
    'shop-profile-orders',
    'shop-profile-order-again',
  ],
  shopping_lists: [
    'shop-list-list_name',
  ],
  faq: [
    'faq',
  ],
  career: [
    'karrier-allas-slug-j-id',
    'karrier-ajanlatok-applicationGuid',
    'karrier-hirek',
  ],
  prize_game: [
    'prize-game',
  ],
  inspirations: [
    'inspirations',
  ],
  csr: [
    'csr',
  ],
  press_room: [
    'press',
  ],
  news: [
    'news',
    'news-type-slug',
  ],
  gas_stations: [
    'petrol-slug',
    'petrol-faq',
  ],
  stores: [
    'stores',
    'stores-slug',
  ],
};

/**
 * Maps pageType keys to the CMS contentRootTypes values that trigger them (for [...slug] catch-all CMS pages).
 * A pageType matches if any of its listed contentRootTypes is present in the CMS page's contentRootTypes array.
 * Note: contentRootTypes values do not always match pageType keys directly (e.g. press_release → press_room).
 */
export const CONTENT_ROOT_TYPE_TO_PAGE_TYPE: Record<string, string[]> = {
  career: ['career', 'career_news'],
  csr: ['csr'],
  prize_game: ['prize_draw'],
  inspirations: ['inspiration'],
  news: ['news'],
  press_room: ['press_release'],
  gas_stations: ['petrol'],
};

/**
 * Maps urlResourceStore.data.resourceType to a pageType key,
 * only the [...slug] catch-all route case (SEO-friendly URLs: .p-, .c-, .b-.c-).
 */
export const RESOURCE_TYPE_TO_PAGE_TYPE: Record<string, string> = {
  product: 'product',
  category: 'product_list',
  boutique: 'boutiques',
  cms_content: 'other_cms',
};
